module.exports = __webpack_public_path__ + "static/media/pathFirstLight.9c060218.svg";